import React, { HTMLAttributes } from 'react'

interface CommonAgreementProps {
  id: HTMLAttributes<HTMLSpanElement>['id']
  text: string
}

export const CommonAgreement = ({ id, text }: CommonAgreementProps) => {
  return <span id={id} dangerouslySetInnerHTML={{ __html: text }} />
}
